import { Link } from 'react-router-dom';
import type { Story } from '@/lib/content';

type StoryCardProps = {
  story: Story;
  rank?: number;
};

export default function StoryCard({ story, rank }: StoryCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/article/${story.id}`} className="block" aria-label={story.title}>
        <div className="relative aspect-[4/3] w-full overflow-hidden bg-background-200">
          <img
            src={story.cover}
            alt={story.coverAlt}
            title={`${story.title} - 5看料网速览`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
          <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2.5 py-1 font-label text-xs font-medium text-primary-700 backdrop-blur">
            {story.categoryName}
          </span>
          {typeof rank === 'number' && (
            <span className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
              {rank}
            </span>
          )}
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-3 font-label text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line text-sm" aria-hidden="true"></i>
            {story.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line text-sm" aria-hidden="true"></i>
            {story.readTime}
          </span>
        </div>

        <h3 className="mt-2.5 font-heading text-base font-semibold leading-snug text-foreground-950">
          <Link to={`/article/${story.id}`} className="transition-colors hover:text-primary-600">
            {story.title}
          </Link>
        </h3>

        <p className="mt-2 line-clamp-3 font-body text-sm leading-relaxed text-foreground-600">
          {story.summary}
        </p>

        <div className="mt-4 flex flex-wrap items-center justify-between gap-2 border-t border-background-200 pt-3.5">
          <div className="flex flex-wrap gap-1.5">
            {story.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="rounded-md bg-secondary-100 px-2 py-0.5 font-label text-xs text-secondary-900"
              >
                {tag}
              </span>
            ))}
          </div>
          <span className="flex items-center gap-1 font-label text-xs text-accent-700">
            <i className="ri-fire-line text-sm" aria-hidden="true"></i>
            {story.heat}
          </span>
        </div>
      </div>
    </article>
  );
}